<template>
  <div>
    <div v-if="past">
      <EmptySpace
        illustration="no_history_goals.svg"
        subheader="What happened that month? Was it a good or bad month? By planning and recording your progress, you will ensure that you will never forget your magnificent progress on your journey."
        subsubheader="Don't worry, you are on the right path now.">
        <template v-slot:header><h2>You didn’t add anything<br>in {{monthInWords}}</h2></template>
      </EmptySpace>
    </div>
    <div v-else>
      <div v-if="hasSomeGoals">
        <EmptySpace
         illustration="calendar.svg"
         subheader="By setting priorities, you create a laser focus for maximum results with minimal effort. Planning helps you to get your life under control, to use your energy and time wisely.">
         <template v-slot:header><h2>You have not yet set your priorities<br>for {{monthInWords}}</h2></template>

          <vs-button class="mt-2" @click="$router.push({ name: 'goals-planner', query: { period: period.toISOString() } })">Plan Goals for {{monthInWords}}</vs-button>
        </EmptySpace>
      </div>
      <div v-else>
        <Header title="Plan your first goal" />
        <vs-button @click="$router.push({ name: 'goals-planner', query: { period: period.toISOString() } })">
          Create Your First Goal
        </vs-button>
        <FocusPreview class="mt-10" />
      </div>
    </div>
  </div>
</template>
<script>
import FocusPreview from '../Preview/FocusPreview'
import EmptySpace from '../Preview/EmptySpace'

export default {
  components: {
    FocusPreview,
    EmptySpace
  },
  props: {
    hasSomeGoals: {
      type: Boolean,
      required: false,
      default: () => false
    },
    past: {
      type: Boolean,
      required: true,
    },
    monthInWords: {
      type: String,
      required: true,
    },
    period: {
      type: Date,
      required: false,
      default: () => null,
    }
  },
}
</script>
